export default __webpack_public_path__ + "static/media/calendarRed.5e7632b7.svg";